import React from 'react'
import { Outlet } from 'react-router-dom'

function MainInvoiceOut() {
    return (
        <div className="w-full h-full">
        <Outlet/>
        </div>
      )
    }
    

export default MainInvoiceOut